import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft, Shield, Calendar, FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Profile() {
  const { userId } = useParams();
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/profile/${userId}`).then(r => setP(r.data)).catch(() => setP(null)).finally(() => setLoading(false));
  }, [userId]);

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
      <Header />
      <main className="max-w-3xl mx-auto px-5 lg:px-8 pt-10 pb-24">
        <Link to="/" className="pill-btn text-sm"><ArrowLeft size={14} /> Ana Sayfa</Link>

        {loading && <div className="mt-8 card-soft rounded-3xl h-80 animate-pulse" />}

        {!loading && !p && (
          <div className="mt-10 card-soft rounded-2xl p-10 text-center">
            <h2 className="text-2xl font-semibold">Profil bulunamadı</h2>
          </div>
        )}

        {!loading && p && (
          <div className="mt-8 card-soft rounded-3xl overflow-hidden">
            <div className="p-8 lg:p-10 flex flex-col sm:flex-row gap-6 items-center sm:items-start">
              {p.avatar ? (
                <img src={p.avatar} alt={p.name} className="w-28 h-28 rounded-2xl" style={{ background: 'var(--pill-hover)' }} />
              ) : <div className="w-28 h-28 rounded-2xl" style={{ background: 'var(--pill-hover)' }} />}
              <div className="flex-1 text-center sm:text-left">
                <h1 className="text-2xl lg:text-3xl font-semibold tracking-tight">{p.displayName || p.name}</h1>
                <div className="mt-1" style={{ color: 'var(--text-muted)' }}>@{p.name}</div>
                <div className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold" style={{ background: 'var(--pill-hover)' }}>
                  <Shield size={12} /> {p.rankName} • Rank {p.rank}
                </div>
                {p.description && <p className="mt-4 text-sm" style={{ color: 'var(--text-muted)' }}>{p.description}</p>}
              </div>
            </div>

            <div className="border-t" style={{ borderColor: 'var(--border)' }}>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-0">
                <div className="p-6 border-r" style={{ borderColor: 'var(--border)' }}>
                  <div className="text-xs uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>User ID</div>
                  <div className="mt-2 text-xl font-semibold">{p.id}</div>
                </div>
                <div className="p-6 sm:border-r" style={{ borderColor: 'var(--border)' }}>
                  <div className="text-xs uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>Grup Rütbesi</div>
                  <div className="mt-2 text-xl font-semibold">{p.rank}</div>
                </div>
                <div className="p-6 col-span-2 sm:col-span-1">
                  <div className="text-xs uppercase tracking-wider flex items-center gap-1" style={{ color: 'var(--text-muted)' }}><FileText size={12} /> Wiki Katkı</div>
                  <div className="mt-2 text-xl font-semibold">{p.wikiCount || 0}</div>
                </div>
              </div>
              {p.created && (
                <div className="p-6 border-t flex items-center gap-2 text-sm" style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}>
                  <Calendar size={14} /> Roblox’a katıldı: {new Date(p.created).toLocaleDateString('tr-TR')}
                </div>
              )}
            </div>

            <div className="p-6 border-t flex flex-wrap gap-2" style={{ borderColor: 'var(--border)' }}>
              <a href={`https://www.roblox.com/users/${p.id}/profile`} target="_blank" rel="noreferrer" className="pill-btn text-sm">Roblox Profili</a>
              <a href={`https://www.roblox.com/groups/14905199`} target="_blank" rel="noreferrer" className="pill-btn text-sm">Grubu Görüntüle</a>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
